<template>
  <div class="login-container">
    <div class="login-background">
      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
      </div>
    </div>
    
    <div class="login-content">
      <div class="login-card">
        <div class="login-header">
          <div class="logo-circle">
            <i class="fa fa-graduation-cap"></i>
          </div>
          <h1 class="login-title">Bienvenido</h1>
          <p class="login-subtitle">American School Way</p>
          <div class="title-underline"></div>
        </div>
        
        <div class="login-form-wrapper">
          <user-form
            :isLogin="true"
            :user="user"
            btnText="Iniciar Sesión"
            v-on:processUserForm="processLogin($event)"
          ></user-form>
        </div>
        
        <div class="login-footer">
          <div class="colombia-flag-mini">
            <div class="flag-mini-yellow"></div>
            <div class="flag-mini-blue"></div>
            <div class="flag-mini-red"></div>
          </div>
          <p class="footer-text">Programador de Clases (Administrador)</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions,mapMutations} from 'vuex';
  import UserForm from "./UserForm";
  export default {
    components: {UserForm},
    name: 'login',
    data () {
      return {
        user: {
          email: '',
          password: '',
        },
      }
    },
    methods: {
      ...mapActions({
        login: 'auth/login',
        fetchSede: 'auth/fetchSede',
        getPermisos: 'auth/getPermisos'
      }),
      ...mapMutations({

      }),
      processLogin (user) {
        this.login({
          email: user.email,
          password: user.password
        }).then(user => {
            this.getPermisos();
            this.fetchSede()
            this.$router.push('/');
          }, error => {
            
          })
      }
    }
  }
</script>

<style scoped>
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 2.5rem 1rem;
}

.login-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0D4E8C 0%, #084079 50%, #052e5c 100%);
  z-index: 0;
}

.floating-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  animation: float 20s infinite ease-in-out;
}

.shape-1 {
  width: 300px;
  height: 300px;
  top: -150px;
  left: -100px;
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  top: 50%;
  right: -50px;
  animation-delay: -5s;
  animation-duration: 15s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  bottom: -75px;
  left: 30%;
  animation-delay: -10s;
  animation-duration: 25s;
}

.shape-4 {
  width: 250px;
  height: 250px;
  bottom: 20%;
  right: 20%;
  animation-delay: -15s;
  animation-duration: 18s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) translateX(0) rotate(0deg);
    opacity: 0.05;
  }
  25% {
    transform: translateY(-30px) translateX(20px) rotate(90deg);
    opacity: 0.1;
  }
  50% {
    transform: translateY(-50px) translateX(-20px) rotate(180deg);
    opacity: 0.08;
  }
  75% {
    transform: translateY(-30px) translateX(30px) rotate(270deg);
    opacity: 0.06;
  }
}

.login-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 450px;
  animation: slideUp 0.8s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.login-header {
  background: linear-gradient(135deg, #0D4E8C 0%, #052e5c 100%);
  padding: 2rem;
  text-align: center;
  position: relative;
}

.login-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30px;
  background: #ffffff;
  border-radius: 50% 50% 0 0 / 100% 100% 0 0;
}

.logo-circle {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid rgba(255, 255, 255, 0.3);
  animation: pulse 2s infinite;
  backdrop-filter: blur(10px);
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 20px 10px rgba(255, 255, 255, 0);
  }
}

.logo-circle i {
  font-size: 2.5rem;
  color: #ffffff;
}

.login-title {
  font-size: 2rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.5rem;
  letter-spacing: 0.5px;
}

.login-subtitle {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-weight: 300;
}

.title-underline {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, transparent, #ffffff, transparent);
  margin: 1rem auto 0;
  animation: glow 2s infinite;
}

@keyframes glow {
  0%, 100% {
    opacity: 0.5;
    transform: scaleX(1);
  }
  50% {
    opacity: 1;
    transform: scaleX(1.2);
  }
}

.login-form-wrapper {
  padding: 2rem;
}

.login-footer {
  background: #f8f9fa;
  padding: 1.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  border-top: 1px solid #e0e0e0;
}

.colombia-flag-mini {
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  width: 30px;
}

.flag-mini-yellow {
  background-color: #FCD116;
  height: 6px;
}

.flag-mini-blue {
  background-color: #003893;
  height: 3px;
}

.flag-mini-red {
  background-color: #CE1126;
  height: 3px;
}

.footer-text {
  margin: 0;
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 400;
}

/* Responsive */
@media (max-width: 576px) {
  .login-container {
    padding: 1rem;
  }
  
  .login-header {
    padding: 2rem 1.5rem 2rem;
  }
  
  .login-form-wrapper {
    padding: 2rem 1.5rem 1.5rem;
  }
  
  .login-footer {
    padding: 1rem 1.5rem;
  }
  
  .login-title {
    font-size: 1.75rem;
  }
  
  .logo-circle {
    width: 70px;
    height: 70px;
  }
  
  .logo-circle i {
    font-size: 2rem;
  }
}

/* Estilos globales para el formulario dentro del login */
.login-form-wrapper >>> .form-group {
  margin-bottom: 1.5rem;
}

.login-form-wrapper >>> label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.login-form-wrapper >>> .form-control {
  border-radius: 10px;
  border: 2px solid #e0e0e0;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.login-form-wrapper >>> .form-control:focus {
  border-color: #0D4E8C;
  box-shadow: 0 0 0 0.2rem rgba(13, 78, 140, 0.15);
}

.login-form-wrapper >>> .btn {
  width: 100%;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #0D4E8C 0%, #052e5c 100%);
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(13, 78, 140, 0.3);
}

.login-form-wrapper >>> .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(13, 78, 140, 0.4);
}

.login-form-wrapper >>> .btn:active {
  transform: translateY(0);
}
</style>
